<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">菜品留样添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品所属的日期" required prop="time">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="addForm.time"
                                        type="date"
                                        placeholder="请选择菜品所属的日期"
                                        value-format="yyyy-MM-dd"
                                        :clearable='false'
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="存放时间" required prop="startTime">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="addForm.startTime"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="请选择菜品存放时间"
                                        :clearable='false'
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品类别" required prop="dishesType">
                                    <el-select
                                        v-model="addForm.dishesType"
                                        placeholder="请选择菜品类别"
                                        style="width:100%">
                                        <el-option
                                            v-for="item in dishesTypeValue"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品是否异常" required prop="status">
                                    <el-radio-group v-model="addForm.status" style="width:100%">
                                        <el-radio :label="0">正常</el-radio>
                                        <el-radio :label="1">异常</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="18" class="item">
                                <el-form-item label="菜品" required prop="dishesCodeArr">
                                    <el-select
                                        v-model="addForm.dishesCodeArr"
                                        multiple
                                        filterable
                                        style="width:100%"
                                        placeholder="请选择留样的菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="样品图片" required>
                                    <el-upload
                                        ref="upload"
                                        :action="uploadUrl"
                                        :data='uploadData'
                                        :on-success="uploadSuccess"
                                        list-type="picture-card"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="handleRemove"
                                        style="margin-top:40px">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="18" class="item">
                                <el-form-item label="备注" required prop="remarks">
                                    <el-input v-model="addForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
                 
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" top='30vh' :modal-append-to-body='false'>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                loading: false,
                floor:null,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    time:'',
                    startTime:'',
                    remarks:'',
                    status:'',
                    dishesCodeArr:[],
                    dishesType:'',
                    dishesImg:'',
                },
                imgList:[],
                dialogImageUrl:'',
                dialogVisible:false,
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                dishesTypeValue:['早餐','中餐','晚餐'],
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择菜品所属的日期', trigger: 'blur' },
                    ],
                    startTime:[
                        { required: true, message: '请选择菜品存放时间', trigger: 'blur' },
                    ],
                    dishesCodeArr:[
                        { required: true, message: '请选择留样的菜品', trigger: 'blur' },
                    ],
                    status:[
                        { required: true, message: '菜品是否异常', trigger: 'blur' },
                    ],
                    dishesType:[
                        { required: true, message: '请选择菜品类别', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            uploadSuccess(response){
                if(response.error == 0){
                    this.imgList.push(response.data.path)
                }else if(response.error == 1){
                    this.$message({type: 'info', message: response.message});
                }
            },
            handleRemove(file) {
                var index=this.imgList.indexOf(file.response.data.path)
                this.imgList.splice(index)
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(this.addForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.imgList.length==0){
                    this.$message.error('请上传样品图片')
                    return
                }
                this.addForm.dishesImg=this.imgList.join(',')
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesCheckRecord/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 730px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: auto;
                height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
